var discounts = [];
discounts.push([8000, 5, "RWD1", "Free Shipping"]);
discounts.push([25000, 5, "RWD2", "Percentage Off"]);
discounts.push([50000, 20, "RWD3", "Percentage Off"]);

//A wrapper to encapsulate all the code
(function (window) {
  function initProgressBar() {
    var ProgressBar = {};
    ProgressBar.singleStepAnimation = 1000; //default value
    // this delay is required as browser will need some time in rendering and then processing css animations.
    var renderingWaitDelay = 200;

    // A utility function to create an element
    var createElement = function (type, className, style, text) {
      var elem = document.createElement(type);
      elem.className = className;
      for (var prop in style) {
        elem.style[prop] = style[prop];
      }
      elem.innerHTML = text;
      return elem;
    };

    var createStatusBar = function(stages, stageWidth, currentStageIndex) {
      var statusBar = createElement('div', 'status-bar', {width: 100 - stageWidth + '%'}, '');
      var currentStatus = createElement('div', 'current-status', {}, '');

      setTimeout(function() {
        currentStatus.style.width = (100 * currentStageIndex)/(stages.length - 1)+'%';
        currentStatus.style.transition = 'width '+(currentStageIndex * ProgressBar.singleStepAnimation)+'ms linear';
      }, renderingWaitDelay);

      statusBar.appendChild(currentStatus);
      return statusBar;
    };

    var createCheckPoints = function(stages, stageWidth, currentStageIndex) {
      var ul = createElement('ul', 'progress-barRB', {margin: 0, padding: 0 }, '');
      var animationDelay = renderingWaitDelay;
      for (var index = 0; index < stages.length; index++) {
        var li = createElement('li', 'sectionRB', {width: stageWidth + '%'}, stages[index]);
        if(currentStageIndex >= index) {
          setTimeout(function(li, currentStageIndex, index) {
            li.className+= (currentStageIndex > index)?' visited': ' visited current';
          }, animationDelay, li, currentStageIndex, index);
          animationDelay+= ProgressBar.singleStepAnimation;
        }
        ul.appendChild(li);
      }
      return ul;
    };

    var createHTML = function (wrapper, stages, currentStage) {
      var stageWidth = 100 / stages.length;
      var currentStageIndex = stages.indexOf(currentStage);

      //create status bar
      var statusBar = createStatusBar(stages, stageWidth, currentStageIndex);
      wrapper.appendChild(statusBar);

      //create checkpoints
      var checkpoints = createCheckPoints(stages, stageWidth, currentStageIndex);
      wrapper.appendChild(checkpoints);

      return wrapper;
    };

    var validateParameters = function(stages, currentStage, container) {
      if(!(typeof stages === 'object' && stages.length && typeof stages[0] === 'string')) {
        console.error('Expecting Array of strings for "stages" parameter.');
        return false;
      }
      if(typeof currentStage !== 'string') {
        console.error('Expecting string for "current stage" parameter.');
        return false;
      }
      if(typeof container !== 'string' && typeof container !== 'undefined') {
        console.error('Expecting string for "container" parameter.');
        return false;
      }
      return true;
    };

    //exposing this function to user;
    ProgressBar.init = function (stages, currentStage, container) {
      if(validateParameters(stages, currentStage, container)) {
        var wrapper = document.getElementsByClassName(container);
        if(wrapper.length > 0) {
          wrapper = wrapper[0];
        } else {
          wrapper = createElement('div', 'progressbar-wrapper', { }, '');
          document.body.appendChild(wrapper);
        }
        createHTML(wrapper, stages, currentStage);
      }
    };
    return ProgressBar;
  }

  if (typeof ProgressBar === 'undefined') {
    window.ProgressBar = initProgressBar();
  } else {
    console.log('Progress bar loaded');
  }

})(window);

setProgressBarOffCartTotal();

function createLabelNotAchieved(data, id){
	var spendX = (Math.round((data[0]/100)));
	var getYOff = data[1];
	var type = data[3];	
	
	switch(type) {
	  case 'Percentage Off':
		  return '<div id="desciptionLabel'+ id +'" class="desciptionLabel">' + 'Spend $' + spendX + ' to unlock<br>NEW Discount Code</div>';
	    break;
	  case 'Fixed Amount':
		  return '<div id="desciptionLabel'+ id +'" class="desciptionLabel">' + 'Spend $' + spendX + ' to unlock<br>NEW Discount Code</div>';
	    break;
	  case 'Free Shipping':
		  return '<div id="desciptionLabel'+ id +'" class="desciptionLabel">' + 'Spend $' + spendX + ' to unlock<br>NEW Discount Code</div>';
	    break;	  
	}	
}

function createLabelAchieved(data, id){
	var spendX = (Math.round((data[0]/100)));
	var getYOff = data[1];
	var type = data[3];
	var code = data[2];
	
	switch(type) {
	  case 'Percentage Off':
		  return '<div id="desciptionLabel'+ id +'" class="desciptionLabel">Use ' + '\'' + code + '\' to receive<br>'+ getYOff +'% OFF</div>';
	    break;
	  case 'Fixed Amount':
		  return '<div id="desciptionLabel'+ id +'" class="desciptionLabel">Use ' + '\'' + code + '\' to receive<br>$'+ getYOff +' OFF</div>';
	    break;
	  case 'Free Shipping':
		  return '<div id="desciptionLabel'+ id +'" class="desciptionLabel">Use ' + '\'' + code + '\' to receive<br> FREE SHIPPING</div>';
	    break;	  
	}	
}
  
var open = window.XMLHttpRequest.prototype.open,
send = window.XMLHttpRequest.prototype.send,
onReadyStateChange;
var urlUsed;

function setDiscountCode(code){
	var xhttp = new XMLHttpRequest()
	xhttp.open("GET", "https://eve-beauty-online.myshopify.com/discount/"+code, true);
	xhttp.send();
}

function createLabel(data){
	var spendX = (Math.round((data[0]/100)));
	var getYOff = data[1];
	var type = data[3];
	
	switch(type) {
	  case 'Percentage Off':
		  return '<div class="desciptionLabel">' + 'Spend $' + spendX + ' get ' + getYOff+ '% off' + '</div>';
	    break;
	  case 'Fixed Amount':
		  return '<div class="desciptionLabel">' + 'Spend $' + spendX + ' get $'+ (Math.round(getYOff)) + ' off'+ '</div>';
	    break;
	  case 'Free Shipping':
		  return '<div class="desciptionLabel">' + 'Spend $' + spendX + ' get Free Shipping'+ '</div>';
	    break;	  
	}	
}

function setProgressBar(step, discountLabels) {
	
	const oldProgressBar = document.getElementById("rewardBarProgressBar");
	if(oldProgressBar){
		oldProgressBar.textContent = '';
	}	
	
	ProgressBar.init(discountLabels, step, 'progress-bar-wrapper');
}

function setProgressBarOffCartTotal() {
	
	const Http = new XMLHttpRequest();
	const url='/cart.js';
	Http.open("GET", url);
	Http.send();

	Http.onreadystatechange = function (){
		
		fetch("/cart.js").then(function(response) {
			  return response.json();
			}).then(function(data) {
			  var ctotal = data.total_price;
			  
			  if(ctotal < discounts[0][0]){
				  var discountLabels = [];
				  
				  var label1 = createLabelNotAchieved(discounts[0])
				  var label2 = createLabelNotAchieved(discounts[1]);
				  var label3 = createLabelNotAchieved(discounts[2]);
				  
				  discountLabels.push(label1);
				  discountLabels.push(label2);
				  discountLabels.push(label3);
				  
				  setProgressBar('', discountLabels);				  
			  }
			  else if(ctotal >= discounts[0][0] &&  ctotal < discounts[1][0] ){				  
				  var discountLabels = [];
				  
				  var label1 = createLabelAchieved(discounts[0])
				  var label2 = createLabelNotAchieved(discounts[1]);
				  var label3 = createLabelNotAchieved(discounts[2]);
				  
				  discountLabels.push(label1);
				  discountLabels.push(label2);
				  discountLabels.push(label3);
				  
				  setProgressBar(label1, discountLabels);	
			  }	  
			  else if(ctotal >= discounts[1][0] && ctotal < discounts[2][0] ){
				  var discountLabels = [];
				  
				  var label1 = createLabelAchieved(discounts[0])
				  var label2 = createLabelAchieved(discounts[1]);
				  var label3 = createLabelNotAchieved(discounts[2]);
				  
				  discountLabels.push(label1);
				  discountLabels.push(label2);
				  discountLabels.push(label3);
				  
				  setProgressBar(label2, discountLabels);					  
			  }
			  else if(ctotal >= discounts[2][0]){
				  var discountLabels = [];
				  
				  var label1 = createLabelAchieved(discounts[0])
				  var label2 = createLabelAchieved(discounts[1]);
				  var label3 = createLabelAchieved(discounts[2]);
				  
				  discountLabels.push(label1);
				  discountLabels.push(label2);
				  discountLabels.push(label3);
				  
				  setProgressBar(label3, discountLabels);			 
			  }
			}).catch(function() {
			});
		
	}
    
  return;
}

const observer2 = new PerformanceObserver((entries) => {
	  entries.getEntriesByType("resource").forEach(
			  request => processPageRequest(request))
	});
observer2.observe({ entryTypes: ["resource"] });

function processPageRequest(request){
	if(request && request.name && request.name.includes("/cart/")){
		setProgressBarOffCartTotal();
	}
}
